import { Typography } from "@mui/material";

export const ValidationError = ({ message }) => {
  return (
    <Typography variant="caption" color="error">
      {message}
    </Typography>
  );
};
